import { Store } from 'pullstate'

export const CommonStore = new Store({
  isShouldUpdateLog: false
})
